import styled from 'styled-components';

const DownloadArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
`;

export default DownloadArea;
